module.exports = __webpack_public_path__ + "img/B922.94ca815f.jpg";